import {put, takeEvery, takeLatest} from "@redux-saga/core/effects";
import {
    boxAction, boxActionError, boxActionSuccess,
    BoxElement, deleteElement, deleteElementError, deleteElementSuccess, getAllElementBox, getAllElementBoxNotPageable,
    getAllElementError, getAllElementErrorBoxNotPageable, GetAllElementPayloadBox,
    getAllElementSuccess, getAllElementSuccessBoxNotPageable,
    saveElement, saveElementError,
    saveElementSuccess, updateElement, updateElementError, updateElementSuccess
} from "../reducers/Box/BoxReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";
import {all, fork} from "redux-saga/effects";

interface BoxFilter {
    name: string | null,
    nameShed: string | null

}

function* getAllElementSaga() {
    yield takeEvery(getAllElementBox.type, function* (action: PayloadAction<GetAllElementPayloadBox>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({ type: getAllElementError.type });
            return;
        }

        const { pageableDto } = action.payload;
        let response: CustomFetchResponse

        try {

                let filters: BoxFilter = {
                    name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? "",
                    nameShed : action.payload.filters?.find(filter => filter.id === "shedId_name")?.value as string ?? ""
                }

                let requestPayload = {
                    ...action.payload.pageableDto,
                    filters:filters
                }

                response = yield CustomFetch(
                    {
                        method: "POST",
                        url: apiPaths.searchBox,
                        authenticated: true,
                        data: requestPayload
                    }
                )

            if (response.status === 200){
                yield put(
                    {
                        type: getAllElementSuccess.type,
                        payload: response.data
                    }
                )
            } else {
                yield put({ type: getAllElementError.type });
            }
            }
            catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({ type: getAllElementError.type });
        }
    });
}

function* getAllElementWithoutPageableSaga() {
    yield takeEvery(getAllElementBoxNotPageable.type, function* (action: PayloadAction<BoxElement>) {
        let response : CustomFetchResponse = yield CustomFetch(
            {
                method:"GET",
                url: apiPaths.allBoxWithoutPageable,
                authenticated: true,
            }
        )
        if (response.status === 200) {
            yield put({
                type: getAllElementSuccessBoxNotPageable.type,
                payload: response.data
            })

        } else {
            yield put({
                type: getAllElementErrorBoxNotPageable.type,
            })
        }

    })
}

function* saveElementSaga() {
    yield takeEvery(saveElement.type, function* (action: PayloadAction<{box: BoxElement , callback: () => void}>) {
        const savePayload = {
            name: action.payload.box.name,
            maxCapacity: action.payload.box.maxCapacity,
            isMaintenance: action.payload.box.isMaintenance,
            isAvailable: action.payload.box.isAvailable,
            shedId: action.payload.box.shedId?._id || action.payload.box.shedId,
            addDogId: action.payload.box.addDogId.map(dog => dog._id) || [],
        };


        let response: CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.saveBox,
            authenticated: true,
            data: savePayload,
        });

        if (response.status === 200) {
            yield put({ type: saveElementSuccess.type, payload: response.data });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Box added successfully',
                    variant: 'alert',
                    alert: { color: 'success' }
                }
            });
            action.payload.callback()
        } else {
            console.error("Error response:", response.data);

            yield put({ type: saveElementError.type });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: response.data?.message || 'Box added error',
                    variant: 'alert',
                    alert: { color: 'error' }
                }
            });
        }
    });
}

function* boxAuditSaga() {
    yield takeEvery(boxAction.type, function* (action: PayloadAction<string>) {
        const url = `${apiPaths.actionBox}/${action.payload}`

        let response : CustomFetchResponse = yield CustomFetch(
            {
                method:"GET",
                url: url,
                authenticated: true,
            }
        )
        if (response.status === 200) {
            yield put({
                type: boxActionSuccess.type,
                payload: response.data
            })

        } else {
            yield put({
                type: boxActionError.type,
            })
        }

    })

}

function* deleteElementSaga(){
    yield takeEvery(
        deleteElement.type,
        function* (action: PayloadAction<{id:string,callback: () => void}>){
            const url = `${apiPaths.deleteBox}/${action.payload.id}`
            let response: CustomFetchResponse = yield CustomFetch(
                {
                    method:"DELETE",
                    url: url,
                    authenticated: true,
                }
            );

            if (response.status === 200){

                action.payload.callback()
                yield put({ type: getAllElementBox.type });

                yield put(
                    {
                        type: deleteElementSuccess.type,
                        payload: response.data.content
                    }
                );
                yield put({
                    type: openSnackbar.type, payload: {
                        open: true,
                        message: 'Element deleted successfully',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    }
                });
            } else {
                yield put(
                    {
                        type: deleteElementError.type
                    }
                );
                yield put({
                    type: openSnackbar.type,
                    payload: {
                        open: true,
                        message: 'Box not deleted',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    }
                });
            }
        }
    )
}

function* updateElementSaga(){
    yield takeEvery(
         updateElement.type,
        function* (action: PayloadAction<{box: BoxElement , callback: () => void}>){
             const url = `${apiPaths.updateBox}/${action.payload.box._id}`;

            const updatePayload = {
                name: action.payload.box.name,
                shedId: action.payload.box.shedId?._id || action.payload.box.shedId,
                maxCapacity: action.payload.box.maxCapacity,
                isMaintenance: action.payload.box.isMaintenance,
                isAvailable: action.payload.box.isAvailable,
                addDogId: action.payload.box.addDogId.map(dog => dog._id),
            }

            let response :  CustomFetchResponse = yield CustomFetch(
                 {
                     method: "PUT",
                     url: url,
                     authenticated: true,
                    data: updatePayload
                 }
             )


            if (response.status === 200){
                yield put(
                    {
                        type: updateElementSuccess.type,
                        payload: response.data
                    }
                )

                yield put({
                    type: openSnackbar.type, payload: {
                        open: true,
                        message: 'Box update success',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    }
                })
               action.payload.callback()
            } else {
                yield put(
                    {
                        type: updateElementError.type
                    }
                );
                yield put({
                    type: openSnackbar.type, payload: {
                        open: true,
                        message: 'Box not update',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    }
                })
            }


        }

    )
}

export default function* BoxSaga(){
    yield all(
        [
            fork(getAllElementSaga),
            fork(getAllElementWithoutPageableSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga),
            fork(boxAuditSaga)
        ]
    )

}